import SlideDown from './SlideDown';

export default SlideDown;
